import { Button } from "@/components/ui/button";
import { ArrowRight, Play } from "lucide-react";

export const HeroSection = () => {
  return (
    <section
      className="relative min-h-screen flex flex-col items-center justify-start pt-32 md:pt-40 pb-8 md:pb-16 overflow-hidden"
      style={{ background: "#FAFAFA" }}>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="font-extrabold tracking-tight mb-4 md:mb-6 leading-[1.1] my-[5px] mx-0 px-px text-7xl font-sans" style={{ color: "#111827", fontSize: "clamp(32px, 5vw, 56px)" }}>
            <span style={{ color: "#F59E0B" }}>500 Followers</span> Is Enough{" "}
            <br />
            To Start Making Money.
          </h1>

          <p className="max-w-4xl mx-auto mb-6 md:mb-8 px-2 md:text-base" style={{ color: "#4B5563", fontSize: "clamp(14px, 1.5vw, 18px)" }}>
            Most creators wait until they're "big enough" to monetise. AI Storycraft Studio turns any audience — 500, 5,000, or 500,000 followers — into real income. One click builds your complete digital product. 
          </p>

          {/* Video Placeholder */}
          <div className="relative w-full max-w-[960px] mx-auto mb-6 md:mb-8">
            <div className="relative overflow-hidden aspect-video rounded-2xl bg-muted" style={{ border: "1px solid #E5E7EB", boxShadow: "0 4px 24px rgba(0,0,0,0.06)", background: "#1e1e1e" }}>
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/90 flex items-center justify-center shadow-2xl">
                  <Play className="w-7 h-7 md:w-9 md:h-9 ml-1" style={{ color: "#7C3AED" }} fill="#7C3AED" />
                </div>
                <p className="text-sm md:text-base" style={{ color: "rgba(255,255,255,0.4)" }}>
                  Product demo video coming soon
                </p>
              </div>
            </div>
          </div>

          <div className="mb-2 px-2">
            <a href="#pricing" className="inline-block w-full md:w-auto">
              <Button variant="hero" size="xl" className="group text-base md:text-lg px-8 py-5 md:px-12 md:py-6 w-full md:w-auto max-w-[400px] btn-interactive">
                Start Your Free Trial
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
          </div>
          <p className="text-xs mb-8 md:mb-12" style={{ color: "#9CA3AF" }}>
            No credit card required. 7-day free trial. Cancel anytime.
          </p>
        </div>
      </div>
    </section>);

};